<script setup lang="ts">
const modalsStore = useModalsStore();

const props = defineProps<{ 
    title: string,
    desc?: string,
    btnTxt?: string,
}>();

function handleOpenModal() {
    modalsStore.openModal('CTA');
};
</script>

<template>
    <SectionsBase class="bg-primary-600 lg:bg-transparent text-white overflow-hidden">
        <div class="container">
            <div 
                class="flex flex-col lg:flex-row items-center justify-between gap-10 relative isolate py-15 lg:py-23.5
                    bg-primary-600 rounded-3xl lg:px-30! lg:overflow-hidden"
            >
                <svg 
                    class="absolute w-100 h-100 -right-full -bottom-1/2 lg:-bottom-full lg:right-1/2 lg:translate-x-1/5 
                        rounded-full bg-primary-50/70 blur-[100px]"
                ></svg>
                <NuxtImg
                    src="/img/new/cloud/03.webp"
                    alt="تلفن ابری"
                    loading="lazy"
                    class="absolute -bottom-3 lg:-bottom-15 w-50 lg:w-125 left-5 lg:left-[22%] mix-blend-screen"
                />
                <div class="relative z-1">
                    <span class="h2 block text-center lg:text-start">{{ props.title }}</span>
                    <p v-if="props.desc" class="text-body1-semibold mt-5 text-center lg:text-start">{{ props.desc }}</p>
                </div>
                <div class="flex flex-col gap-5 relative z-1">
                    <Button
                        :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                        size="Large"
                        variant="white"
                        pill
                        @click="handleOpenModal"
                    >
                        {{ props.btnTxt ? props.btnTxt : 'درخواست مشاوره رایگان' }}
                    </Button>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>